angular.module('mobilezuz')
    .config(['$stateProvider', 'PAGE_ACCESS', function ($stateProvider, PAGE_ACCESS) {
        $stateProvider.state('app.retailer.contactUs', {
            url: '/contact-us',
            data: {
                stateAccess: PAGE_ACCESS.ALLOW,
                bodyClass: 'contact-us',
                metaTags: {
                    title: 'Contact us'
                }
            },
            views: {
                '@': {
                    templateUrl: 'views/contact-us.html',
                    controller: 'ContactUsCtrl',
                    controllerAs: 'contactUsCtrl'
                }
            }
        });
    }])
    .controller('ContactUsCtrl', ['$rootScope', 'Config', 'Retailer', 'User', 'Api', 'mDesign', 'SpCaptcha', 'DataLayer', 'ChooseAreaDialog',
        function ($rootScope, Config, Retailer, User, api, mDesign, SpCaptcha, DataLayer, ChooseAreaDialog) {
            var contactUsCtrl = this,
                userId;

            DataLayer.push(DataLayer.EVENTS.VIEW_CONTACT_US);

            contactUsCtrl.showCaptcha = true;
            contactUsCtrl.captchaIsInvalid = false; 

            Retailer.getRetailerSettings().then(function (response) {
                contactUsCtrl.retailerPhoneNumber = response.contactPhone || (Config.branch && Config.branch.phone);
            });

            contactUsCtrl.openDialer = function () {
                window.location.href = 'tel:' + contactUsCtrl.retailerPhoneNumber;
            };

            if (User.getUserLoginData()) {
                User.getUserSettings().then(function (userData) {
                    userId = userData.id;
                    contactUsCtrl.name = userData.firstName + ' ' + userData.lastName;
                    contactUsCtrl.email = userData.email;
                    contactUsCtrl.phone = userData.phones && userData.phones.length ? pickPhoneNumber(userData.phones) : '';
                });
            }

            function pickPhoneNumber(phones) {
                var mobileNumber = phones.filter(function (phone) {
                    return phone.typeVal === 3;
                });
                if (mobileNumber.length > 0) {
                    return mobileNumber[0].phoneNumber;
                } else {
                    return phones[0].phoneNumber;
                }
            }

            contactUsCtrl.sendData = function (form) {
                if (angular.isUndefined($rootScope.config.getBranchArea())){
                    return ChooseAreaDialog.show(false);
                }

                if(form.$invalid) {
                    angular.forEach(form.$error.required, function(field) {
                        if (field.$$attr.id === 'captcha_hidden_input') {
                            contactUsCtrl.captchaIsInvalid = true;
                        }
                    });
                    return;
                }
                var data = {
                    email: contactUsCtrl.email,
                    message: contactUsCtrl.message,
                    name: contactUsCtrl.name,
                    phone: contactUsCtrl.phone,
                    branchId: Config.branch.id,
                    recaptchaHash: SpCaptcha.getLastCaptchaVerifyHash()
                };
                if (userId) {
                    data.userId = userId;
                }
                api.request({
                    method: 'POST',
                    url: 'retailers/:rid/contactUs',
                    data: data
                }).then(function () {
                    $rootScope.$emit('contactUs', contactUsCtrl.email, contactUsCtrl.name);
                    DataLayer.push(DataLayer.EVENTS.CONTACT_US);
                    return mDesign.alert('Your message was sent successfully');
                }).then(function () {
                    window.history.go(-1);
                }).catch(function (err) {
                    DataLayer.push(DataLayer.EVENTS.ERROR_CONTACT_US, {data: {error: err}});
                });
            };
        }]);